import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { GripVertical } from 'lucide-react';

interface ResizableContainerProps {
  children: React.ReactNode;
  minWidth?: number;
  maxWidth?: number;
  defaultWidth?: number;
}

export function ResizableContainer({
  children,
  minWidth = 800,
  maxWidth = 1400,
  defaultWidth = 1000
}: ResizableContainerProps) {
  const [width, setWidth] = useState(defaultWidth);
  const [isDragging, setIsDragging] = useState(false);

  return (
    <div className="relative mx-auto" style={{ width: width }}>
      {children}
      
      <motion.div
        drag="x"
        dragMomentum={false}
        dragConstraints={{
          left: minWidth - width,
          right: maxWidth - width
        }}
        onDragStart={() => setIsDragging(true)}
        onDragEnd={() => setIsDragging(false)}
        onDrag={(_, info) => {
          const newWidth = Math.max(minWidth, Math.min(maxWidth, width + info.offset.x));
          setWidth(newWidth);
        }}
        className={`absolute -right-4 top-0 bottom-0 w-8 flex items-center justify-center cursor-col-resize group ${
          isDragging ? 'z-50' : 'z-30'
        }`}
      >
        <div className="w-1 h-12 rounded-full bg-gray-200 group-hover:bg-gray-400 transition-colors flex items-center justify-center">
          <GripVertical className="w-4 h-4 text-gray-400 group-hover:text-gray-600" />
        </div>
      </motion.div>

      <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-sm text-gray-500">
        {Math.round(width)}px
      </div>
    </div>
  );
}